import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { useChartData } from "../../context/ChartDataContext";

const ApexChart6 = () => {
	const [state, setState] = React.useState({
		series: [{
			name: 'T_K (K)',
			data: []
		}],
		options: {
			chart: {
				id: 'area-datetime6',
				type: 'area',
				height: 350,
				zoom: {
					autoScaleYaxis: true
				},
				toolbar: {
					show: true,
					tools: {
						download: true,
						selection: true,
						zoom: true,
						zoomin: true,
						zoomout: true,
						pan: true,
						reset: true,
						customIcons: []
					},
					export: {
						csv: {
							filename: 'temperature-data',
							columnDelimiter: ',',
							headerCategory: 'Date',
							headerValue: 'Temperature (K)',
						},
						png: {
							filename: 'temperature-chart',
						},
						svg: {
							filename: 'temperature-chart',
						},
					}
				}
			},
			colors: ['#FF6B35'],
			annotations: {
				yaxis: [{
					y: 30,
					borderColor: '#999',
					label: {
						show: true,
						text: 'Support',
						style: {
							color: "#fff",
							background: '#00E396'
						}
					}
				}],
				xaxis: [{
					x: new Date('14 Nov 2012').getTime(),
					borderColor: '#999',
					yAxisIndex: 0,
					label: {
						show: true,
						text: 'Rally',
						style: {
							color: "#fff",
							background: '#775DD0'
						}
					}
				}]
			},
			dataLabels: {
				enabled: false
			},
			markers: {
				size: 0,
				style: 'hollow',
			},
			xaxis: {
				type: 'datetime',
				tickAmount: 6,
			},
			yaxis: {
				labels: {
					formatter: function (value) {
						return value.toFixed(0);
					}
				}
			},
			tooltip: {
				x: {
					format: 'dd MMM yyyy HH:MM'
				},
				y: {
					formatter: function (value) {
						return value.toFixed(1) + ' C';
					}
				},
				style: {
					fontSize: '16px'
				}
			},
			fill: {
				type: 'gradient',
				gradient: {
					shadeIntensity: 1,
					opacityFrom: 0.3,
					opacityTo: 0.6,
					stops: [0, 100]
				}
			},
		}
	});

	const { chartData, loading, error } = useChartData();

	useEffect(() => {
		// Use shared chart data instead of making API call
		if (chartData && chartData.TMBS) {
			console.log("Using shared TMBS data:", chartData.TMBS);
			
			// Calculate the actual data range with small buffer
			const timestamps = chartData.TMBS.map(point => point[0]);
			const values = chartData.TMBS.map(point => point[1]);
			
			const minTime = Math.min(...timestamps);
			const maxTime = Math.max(...timestamps);
			const minValue = Math.min(...values);
			const maxValue = Math.max(...values);
			
			// Add small buffer (5% of range) around the data
			const timeRange = maxTime - minTime;
			const valueRange = maxValue - minValue;
			const timeBuffer = timeRange * 0.05; // 5% buffer
			const valueBuffer = valueRange * 0.05; // 5% buffer
			
			// Make sure data is in format: [[timestamp, value], ...]
			setState(prev => ({
				...prev,
				series: [{
					name: 'TMBS (K)',
					data: chartData.TMBS
				}],
				options: {
					...prev.options,
					xaxis: {
						...prev.options.xaxis,
						min: minTime - timeBuffer,
						max: maxTime + timeBuffer
					},
					yaxis: {
						...prev.options.yaxis,
						min: minValue - valueBuffer,
						max: maxValue + valueBuffer
					}
				}
			}));
		}
	}, [chartData]);

	return (
		<div>
			<div id="chart">
				<div id="chart-timeline">
					<ReactApexChart options={state.options} series={state.series} type="area" height={350} />
				</div>
			</div>
			<div id="html-dist"></div>
		</div>
	);
}

export default ApexChart6;